import React, {FC} from 'react';
import {ElementWrapper} from '../element-wrapper/element-wrapper.component';
import {ReactComponent as SearchIcon} from '../../assets/search-icon.svg';
import { DebounceInput } from 'react-debounce-input'
type Props = {
 
  placeholder?: string;
    onChange(value: string): void;
    
};

export const SearchField: FC<Props> = ({ onChange, placeholder }) => (
  <ElementWrapper noPadding>
    <div className="relative">
      <div className="absolute left-2 translate-x-2 translate-y-5">
        <SearchIcon />
      </div>
        </div>
        <DebounceInput
            className="w-full h-full p-5 pl-14"
            placeholder={placeholder} 
            minLength={1}
            debounceTimeout={500}
            onChange={e => (onChange(e.target.value))}
        />
  
  </ElementWrapper>
);
